<!-- src/App.vue -->

<template>
  <main>
    <div class="container mx-auto" data-aos="fade-right">
      <div class="row justify-content-center mt-3 m-2 dark-gray-box-1">
        <div class="col-12 col-md-6 py-2 mb-3 mb-lg-0 text-align-center">
          <img src="https://r4.sinlessproject.com/media/Assets/goat-skull-lime.png" alt="Distorted Lime Goat skull" class="img-fluid mb-1">
            <h1 class="MainTitleFont textmain">Where am I?</h1>
              <p class="textsecondary fontSize16 textmainglow">
                Welcome fellow sinners, 
                if you’re reading this right now then you’ve stumbled upon the vile works of Lord XV. 
                Here is where you’ll find my art, news and original works such as Sins of Dissentia.
              This site is constantly getting overhauled with new features. May you find pleasure in viewing my sick creations.
              </p>
          </div>
      </div>
    </div>
  </main>
</template>

<script>
  //import imageBlock from './../../components/imageBlock.vue';
  //import HomePagePart1ArtistsNews from '@/HomePagePart1ArtistsNews.vue';
  import 'animate.css';
  
  export default {
    name: 'AboutPage',
    components: {
    //imageBlock,
    //HomePagePart1ArtistsNews,
   
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
        showB1:  false,
        showB2:  false,
        showB3:  false,
        showB4:  false,
        showB5:  false,
        isClassAdded: false,
        apiUrl: '',
      };
    },
    methods: {
      toggle(property) {
        console.log('Toggling', property);
        this[property] = !this[property];
      },
      addClass(event) {
      // Prevent the default navigation
      event.preventDefault();

      // Add the class to trigger the animation
      this.isClassAdded = true;

      // Wait for the animation to complete before navigating
      // Assuming the animation duration is 1 second (1000 milliseconds)
      setTimeout(() => {
        window.location.href = this.apiUrl;
      }, 1000); // Adjust the timeout duration based on your actual animation duration
    },
    },
    mounted(){
      document.title = "Sinless Project Home";
    },
    created() {
      const userAgent = navigator.userAgent;
      if (process.env.NODE_ENV === 'production' || (/Mobi|Android/i.test(userAgent))) {
        this.apiUrl = 'https://dev.sinlessproject.com/subTitleFont';
      } else {
        this.apiUrl = 'http://localhost:8080/subTitleFont';
      }

  },
  }

</script>